// SKIMS-style gallery controls: arrows + dots, built from whatever images the section rendered.
(function(){
  function init(){
    var gal = document.getElementById('gal');
    if (!gal || gal.dataset.bbInit) return;
    gal.dataset.bbInit = '1';
    var wrap = gal.parentNode, n = gal.children.length;
    if (n < 2) return;

    var dots = document.createElement('div');
    dots.className = 'galdots';
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
    wrap.appendChild(dots);

    function mk(dir, label, glyph){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'galnav ' + dir;
      b.setAttribute('aria-label', label); b.textContent = glyph;
      b.addEventListener('click', function(){
        gal.scrollBy({ left: (dir === 'next' ? 1 : -1) * gal.clientWidth, behavior: 'smooth' });
      });
      wrap.appendChild(b); return b;
    }
    mk('prev', 'Previous image', '‹');
    mk('next', 'Next image', '›');

    function paint(){
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      for (var k = 0; k < dots.children.length; k++)
        dots.children[k].className = (k === i ? 'on' : '');
      var c = document.getElementById('galn');
      if (c) c.textContent = (i + 1) + '/' + n;
    }
    gal.addEventListener('scroll', paint, { passive: true });
    paint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
